import React from 'react';
import { Collapsible, CollapsibleContent, CollapsibleContextConsumer, CollapsibleHeading } from '$partials/base/collapsible.jsx';
import IconAdd from '$partials/icons/icon-add';
import IconSubtract from '$partials/icons/icon-subtract';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').PropertyListingAccordionBlock}
 */

const PropertyListingAccordion = ({
    heading,
    subheading,
    items
}) => {

    if (!heading && !items?.length) {return null;}

    return (
        <div className='module-property-listing-accordion theme-light bg-main-background py-16 sm:py-40 md:py-48'>
            <div className='layout-container layout-site-outer-padding'>
                <div className='flex gap-y-32 flex-col md:flex-row col-wrapper'>

                    {/* Left column: heading + subheading */}
                    <div className='md:w-4/12 col-padding'>
                        {heading && (
                            <h2 className='type-style-2 text-main-text-primary'>{heading}</h2>
                        )}
                        {subheading && (
                            <p className='type-style-body-r text-main-text-primary mt-16'>{subheading}</p>
                        )}
                    </div>

                    {/* Right column: accordion */}
                    {items?.length > 0 && (
                        <div className='col-padding md:w-8/12'>
                            {items.map((item, index) => (
                                <Collapsible
                                    id={`property-listing-accordion-${index}`}
                                    isOpened={false}
                                    key={index}>
                                    <CollapsibleHeading className='border-t border-main-border w-full text-left'>
                                        <CollapsibleContextConsumer>
                                            {({ isOpened }) => (
                                                <div className='flex items-center justify-between py-24 gap-x-24'>
                                                    <span className='type-style-4 text-main-text-primary'>{item.heading}</span>
                                                    {isOpened
                                                        ? <IconSubtract className='w-[12px] h-[12px] shrink-0' />
                                                        : <IconAdd className='w-[12px] h-[12px] shrink-0' />
                                                    }
                                                </div>
                                            )}
                                        </CollapsibleContextConsumer>
                                    </CollapsibleHeading>
                                    <CollapsibleContent className='pb-24'>
                                        {item.text && (
                                            <div
                                                className='type-style-body-r text-main-text-primary rich-text'
                                                dangerouslySetInnerHTML={{ __html: item.text }} />
                                        )}
                                    </CollapsibleContent>
                                </Collapsible>
                            ))}
                        </div>
                    )}

                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Exports */
/* ========================================================================= */

export default PropertyListingAccordion;
